export const container = `px-6 pt-6 pb-px lg:p-6 bg-ll-surface`;

export const title = `
  text-ll-primary text-2xl font-semibold leading-7
  mb-2 lg:mb-2.5
`;

export const text = `
  text-ll-on-surface font-normal
  leading-5 lg:leading-6
  text-sm lg:text-lg
`;
